module.exports = __webpack_public_path__ + "img/logo_transparent_dark.b9104f72.png";